import React, {useEffect, useState} from 'react';
import "./AllEventsForDay.scss";
import AllEventsApi from "../../../../api/AllEventsApi";
import * as actionCreators from "../../../../store/actions/actions";
import {connect} from "react-redux";
import EventItem from "../../EventsForDay/EventItem/EventItem";
import Loading from "../../../../components/Loading/Loading";
import UrlManager from "../../../../tools/UrlManager";
import {getLabelFromYearMonthDay} from "../../../../tools/formatter";
import {Grid2} from "@mui/material";

function AllEventsForDay(props) {
    const [dayEvents, setDayEvents] = useState([]);
    const [labels, setLabels] = useState(null);

    const setCurrentNavigationEventId = (eventId) => {
        props.onUpdateCurrentNavigationEventId(eventId);
    }

    useEffect(() => {
        setDayEvents([]);
        if ( props.userId && props.currentNavigationYear && props.currentNavigationMonth && props.currentNavigationDay ) {
            const year = props.currentNavigationYear;
            const month = props.currentNavigationMonth;
            const day = props.currentNavigationDay;
            AllEventsApi.getDay(props.userId, year, month, day).then(response => {
                console.log(response);
                setDayEvents(response.rows);
            } ).catch(error => {
                //TODO catch
            });
            AllEventsApi.getLabels(props.userId, 'e', getLabelFromYearMonthDay(props.currentNavigationYear, props.currentNavigationMonth, props.currentNavigationDay)).then(response => {
                const labelsObject = Object.fromEntries(
                    response.map(item => [item.userdate, { userimage: item.userimage, transform: item.transform ?? null }])
                );
                setLabels(labelsObject);
            } ).catch(error => {
                //TODO catch
            });
        }
    }, [props.userId, props.currentNavigationYear, props.currentNavigationMonth, props.currentNavigationDay]);

    return props.userId && props.currentNavigationYear && props.currentNavigationMonth && props.currentNavigationDay ? (
        <div className="AllEventsForDay">
            <Grid2 container spacing={1}>
                {dayEvents.length > 0 ? dayEvents.map((dayInfo) => {
                    return (
                        <Grid2 sx={{border: props.currentNavigationEventId === dayInfo.eventPath ? '2px solid #1976d2' : ''}}
                               key={dayInfo.eventPath} size={{ xs: 12, sm: 4, lg: 2 }}
                               onClick = {() => {
                                setCurrentNavigationEventId(dayInfo.eventPath);
                                UrlManager.setUrl(props.userId, props.currentNavigationYear, props.currentNavigationMonth, props.currentNavigationDay, dayInfo.eventPath);
                            }}>
                            <EventItem label={labels ? (labels[dayInfo.eventPath] ?? false) : null} item={dayInfo} />
                        </Grid2>
                    )
                }) : <Loading />}
            </Grid2>
        </div>
    ) : '';
}

const mapStateToProps = state => {
    return {
        currentNavigationYear: state.eventsData.currentNavigationYear,
        currentNavigationMonth: state.eventsData.currentNavigationMonth,
        currentNavigationDay: state.eventsData.currentNavigationDay,
        currentNavigationEventId: state.eventsData.currentNavigationEventId,
        currentEvent: state.eventsData.currentEvent
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCurrentNavigationEventId: (currentEventId) => dispatch(actionCreators.updateNavigationEventId(currentEventId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEventsForDay);
